export default "__VITE_ASSET__608c5126__"